var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name === 'home')?_c('div',{staticClass:"menu"},[_c('h1',[_vm._v("Scaife Viewer Demos")]),_c('router-link',{attrs:{"to":{ name: 'reader' }}},[_vm._v("Explore Homer")])],1):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }